import { ShieldCheck, HeartHandshake, Lock, LifeBuoy, Eye, ArrowRight } from "lucide-react";
import { TRUST_CLAUSES, IMAGES } from "../content";
import { Reveal } from "../motion";
import { Section, Wrap, SectionHead } from "./Section";

const ICONS = [Eye, HeartHandshake, Lock, LifeBuoy, ShieldCheck, ArrowRight];

export default function Trust() {
  return (
    <Section id="trust" theme="sage" className="py-16 sm:py-24 overflow-hidden">
      <Wrap>
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          <div className="lg:col-span-5">
            <SectionHead
              eyebrow="Trust, privacy and clinical boundaries"
              title="Enough information to route an enquiry. Never more."
              intro="Written plainly, because the people reading it may be having a difficult day."
            />
            <Reveal delay={3} className="mt-10 hidden lg:block">
              <div className="relative rounded-3xl overflow-hidden h-80">
                <img
                  src={IMAGES.counselling}
                  alt="A private one-to-one conversation in a calm, plant-filled counselling room"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-7">
            <ol className="space-y-0 border-t border-[#26342E]/10">
              {TRUST_CLAUSES.map((c, i) => {
                const Icon = ICONS[i];
                return (
                  <Reveal key={c.title} delay={i * 0.4}>
                    <li className="flex gap-6 py-7 border-b border-[#26342E]/10 group">
                      <span className="shrink-0 w-11 h-11 rounded-full bg-[#F6F0E6] border border-[#6F806E]/30 flex items-center justify-center text-[#4D5D4C] transition-colors duration-400 group-hover:bg-[#26342E] group-hover:text-[#F6F0E6] group-hover:border-[#26342E]">
                        <Icon size={17} strokeWidth={1.8} />
                      </span>
                      <div>
                        <h3 className="font-serif text-xl sm:text-2xl font-medium text-[#26342E]">{c.title}</h3>
                        <p className="text-sm sm:text-base text-[#26342E]/65 leading-relaxed mt-2 max-w-xl">{c.text}</p>
                      </div>
                    </li>
                  </Reveal>
                );
              })}
            </ol>
          </div>
        </div>
      </Wrap>
    </Section>
  );
}
